export default __webpack_public_path__ + "static/media/smallTruckLeftTablet.e87fe6a1.jpg";